// extracted by mini-css-extract-plugin
export var fullGrid = "_3o-3";
export var pdpPreviewContainer = "_3o-1";
export var previewContainer = "_3o-0";
export var togglePreviewContainer = "_3o-2";